import { useState, useEffect } from 'react';
import { login, verifyToken, configureAxiosAuth, clearAxiosAuth } from '../services/authApi';

export const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>('');

  // Vérifier si l'utilisateur est déjà connecté au chargement
  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem('authToken');
      if (token) {
        const isValid = await verifyToken(token);
        if (isValid) {
          setIsAuthenticated(true);
          configureAxiosAuth(token);
        } else {
          localStorage.removeItem('authToken');
          clearAxiosAuth();
        }
      }
      setIsLoading(false);
    };

    checkAuth();
  }, []);

  const loginUser = async (password: string): Promise<boolean> => {
    setError('');
    try {
      const response = await login(password);
      localStorage.setItem('authToken', response.token);
      configureAxiosAuth(response.token);
      setIsAuthenticated(true);
      return true;
    } catch (error: any) {
      const errorMessage = error.response?.data?.error || 'Erreur de connexion';
      setError(errorMessage);
      return false;
    }
  };

  const logout = () => {
    localStorage.removeItem('authToken');
    clearAxiosAuth();
    setIsAuthenticated(false);
  };

  return {
    isAuthenticated,
    isLoading,
    error,
    login: loginUser,
    logout
  };
};
